import http from '../interceptors/Intercepter';

export const createStaffMember = async (username, systemUserVOToCreate) => {
  try {
    const { data } = await http.post('/api/systemUser/create', { username, systemUserVOToCreate });
    return [data, null];
  } catch (error) {
    return [null, error];
  }
};
export const retrieveStaffMember = async (username, systemUserExternalReference) => {
  try {
    const { data } = await http.post('/api/systemUser/view', { username, systemUserExternalReference });
    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const retrieveAllStaffMembers = async (username) => {
  try {
    const { data } = await http.get('/api/systemUser/viewAll?username=' + username);
    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const retrieveLoggedInSystemUser = async (username) => {
  try {
    const { data } = await http.get('/api/systemUser/retrieveLoggedInSystemUser?username=' + username);
    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const updateStaffMember = async (username, systemUserVOToUpdate) => {
  try {
    const { data } = await http.put('/api/systemUser/update', { username, systemUserVOToUpdate });
    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const deleteStaffMember = async (username, externalReference) => {
  try {
    const { data } = await http.delete('/api/systemUser/delete', { data: { username, externalReference } });
    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const viewSitesForUser = async (username, userExternalReference) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      userExternalReference: userExternalReference,
      username: username,
    };

    const { data } = await http.get('/api/systemUser/viewSitesForUser', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const assignSitesToUser = async (username, assignSitesToUserRequest) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
    };

    const { data } = await http.post('/api/systemUser/assignSitesToUser', assignSitesToUserRequest, {
      params,
      ...config,
    });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};
